const BusinessAndEnterpreneurshipProjects = [
  {
    id:  "project-1",
    title: "Pasayahan 2026: JCI Lucena's Fundraising Fiesta",
    thumbnail: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan1.jpg",
    contentPath: "/project-content/Pasayahan2026.md",
    description: "Raising funds for JCI Lucena’s community projects through a festive booth at the annual Pasayahan festival.",
    division: "business-and-entrepreneurship",
    IsFeatured: true,
    images: [
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan2.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan3.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan4.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan5.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan6.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan7.jpg",
        aspect: "9/16"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan8.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan9.jpg",
        aspect: "16/9"
      },
      {
        path: "/projects/Business-Entrepreneurship/pasayahan-2026/pasayahan10.jpg",
        aspect: "16/9"
      },
    ]
  },
]

export default BusinessAndEnterpreneurshipProjects;